<template>
  <td class="tab-element" :class="[{ tiny, big }, bgColor]">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: 'table-element',

  props: {
    tiny: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
    bgColor: {
      type: String,
      default: 'none',
    },
  },
}
</script>

<style scoped></style>
